import type { TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';
import SettingsCentralMappingDropdownsDropdownCommissionable from 'lumen/components/settings/central-mapping/dropdowns/dropdown-commissionable';
import { TRIGGER_CENTRAL_MAPPING_VARIANTS } from 'lumen/components/settings/central-mapping/dropdowns/triggers/trigger-central-mapping';
import type { Commissionable } from 'lumen/models/central-mapping/mapping-entry-market-segment';

interface MarketSettingsCentralMappingTablesCellsTdCommissionableSignature {
  Args: {
    column: {
      isReadOnly?: boolean;
    };
    row: {
      autoCommissionable: Commissionable;
      commissionable: Commissionable;
      isMixedCommissionable: boolean;
      setCommissionable: (value: Commissionable) => void;
      userCommissionable: Commissionable;
    };
    rowMeta: {
      isSelected: boolean;
    };
  };
}

const MarketSettingsCentralMappingTablesCellsTdCommissionable: TOC<MarketSettingsCentralMappingTablesCellsTdCommissionableSignature> =
  <template>
    <div data-test-id="table-central-mapping-td-commissionable">
      <SettingsCentralMappingDropdownsDropdownCommissionable
        @autoCommissionable={{@row.autoCommissionable}}
        @commissionable={{@row.commissionable}}
        @isMixed={{@row.isMixedCommissionable}}
        @isReadOnly={{or @column.isReadOnly @rowMeta.isSelected}}
        @isSelected={{@rowMeta.isSelected}}
        @setCommissionable={{@row.setCommissionable}}
        @userCommissionable={{@row.userCommissionable}}
        @variant={{TRIGGER_CENTRAL_MAPPING_VARIANTS.SUBDUED}}
      />
    </div>
  </template>;

export default MarketSettingsCentralMappingTablesCellsTdCommissionable;
